// import scrollToElement from "scroll-to-element";
// import tick from "../helpers/async";
// import wait from '../helpers/wait';
// import ReactDOM from 'react-dom';
import Rellax from "rellax";
import Swiper from "swiper";
// import { setCSSCustomProperty } from "../helpers/css";
import { setCSSCustomProperty } from "../scripts/helpers/css";

import { makePopupInstance, PopupController } from '../scripts/controller/popup.controller';
import { SearchInput } from '../components/SearchInput/SearchInput';


const isPage = slug => document.body.classList.contains(slug);

export const UIController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        this.apiLoadPromise();
        // this.testApi();
        this.initMeasurementCheckers();
        this.recordNavBarHeight();
        this.initAccordionTriggers();
        this.wrapPaginationNumbers();
        this.initGuidebookPopup();
        this.initContactPopup();

        this.initRellax();
        
        // this.initFontSelector();

        if (isPage('home')) {
          // this.initHeroSlider();
          this.initTestimonialsSwiper();
        }

        // if(isPage('blog')) {
          // this.wrapPaginationNumbers();
        // }

        resolve();
      } catch (error) {
        reject(error);
      }
    })
  },

  // testApi() {
  //   // Test: Create a new post
  //   // var post = new wp.api.models.Post( { title: 'This is a test post' } );
  //   // post.save();

  //   // fetch('https://localhost:3000/wp-json/wp/v2/search?search=VAT')  
  //   // .then(response => response.json())
  //   // .then(data => console.log(data));
  // },

  apiLoadPromise() {
    wp.api.loadPromise.done( function() {
      console.log('WordpPress API loaded successfully!');
    } )

    // var allCategories = new wp.api.collections.Categories()
    // allCategories.fetch();
    // console.log(allCategories);
  },

  recordWindowDimensions() {
    const { innerWidth, innerHeight } = window;
    setCSSCustomProperty('--vw', innerWidth + 'px');
    setCSSCustomProperty('--vh', innerHeight + 'px');
  },

  recordWpAdminBarHeight() {
    const el = document.getElementById('wpadminbar');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--wp-admin-bar-height', height + 'px');
    return height;
  },

  recordNavBarHeight() {
    const el = document.querySelector('.section-site-nav');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--nav-height', height + 'px');
    return height;
  },

  recordGuidebookBlockquoteHeight() {
    const el = document.querySelector('.guidebook__aside-blockquote');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--guidebook-blockquote-height', height + 'px');
    // console.log(height);
    return height;
  },

  recordInsightsHeaderHeight() {
    const el = document.querySelector('.insights__header');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--insights-header-height', height + 'px');
    // console.log(height);
    return height;
  },

  recordGuidebookHeight() {
    const el = document.querySelector('.guidebook__main-content');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--guidebook-main-content-height', height + 'px');
    // console.log(height);
    return height;
  },

  initMeasurementCheckers() {
    const handleWindowLoad = () => {
      this.recordWindowDimensions();
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
      this.recordGuidebookBlockquoteHeight();
      this.recordGuidebookHeight();
      this.recordInsightsHeaderHeight();
      // this.recordNavSearchBarHeight();
      // this.recordHeaderHeight();
    }
    const handleWindowResize = () => {
      this.recordWindowDimensions();
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
      this.recordGuidebookBlockquoteHeight();
      this.recordGuidebookHeight();
      this.recordInsightsHeaderHeight();
      // this.recordNavSearchBarHeight();
      // this.recordHeaderHeight();
    }
    window.addEventListener('load', handleWindowLoad);
    // window.addEventListener('scroll', handleWindowLoad);
    window.addEventListener('resize', handleWindowResize);
  },

  initTestimonialsSwiper() {
    if(document.querySelector('.testimonial__thumbs-swiper-container')) {
      var galleryThumbs = new Swiper('.testimonial__thumbs-swiper-container', {
        slidesPerView: 8,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        allowTouchMove: false, // TODO: Check to implement thumbs like swiper demo only for mobile
      });
    }
  
    if(document.querySelector('.testimonials__quote-swiper-container')) {
      new Swiper('.testimonials__quote-swiper-container', {
      // var galleryTop = new Swiper('.testimonials__quote-swiper-container', {
        loop: true,
        thumbs: {
          swiper: galleryThumbs,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
      });
    }
  },

  wrapPaginationNumbers() {
    try {
      const pagination = document.querySelector('.nav-links');
      // const navigation = document.querySelector('pagination-links');
      if (!pagination && !navigation) return;
      
      const currentWrapper = "";

      // if(pagination) {
      //   currentWrapper = pagination;
      // };

      // if(navigation) {
      //   currentWrapper = navigation;
      // }

      const numbers = pagination.querySelectorAll('.page-numbers:not(.prev):not(.next)');
      const numbersList = document.createElement('div');
      numbersList.classList.add('page-numbers-list');
      numbersList.append(...Array.from(numbers));
      pagination.insertBefore(numbersList, pagination.lastChild);
    } catch(e) {
      console.warn('Failed to wrap pagination numbers, ignoring this error.');
    }
  },

  // initHeroSlider() {
  //   const slides = document.querySelectorAll('.hero-banner-slides .featured-slider-card .review-slider-card .swiper-slide');
  //   if (slides.length === 1) return;
  //   new Swiper('.hero-banner-slides', {
  //     loop: true,
  //     slidesPerView: 1,
  //     spaceBetween: 0,
  //     navigation: {
  //       nextEl: '.swiper-button-next',
  //       prevEl: '.swiper-button-prev',
  //     },
  //     pagination: {
  //       el: '.swiper-pagination',
  //       clickable: true,
  //     },
  //   });
  //   new Swiper('.featured-slider-card', {
  //     spaceBetween: 0,
  //     centeredSlides: true,
  //     effect: 'fade',
  //     loop: true,
  //     autoplay: {
  //       delay: 3500,
  //       disableOnInteraction: false,
  //     },
  //     pagination: {
  //       el: '.swiper-pagination',
  //       clickable: true,
  //     },
  //     navigation: {
  //       nextEl: '.swiper-button-next',
  //       prevEl: '.swiper-button-prev',
  //     },
  //   });
  //   new Swiper('.review-slider-card', {
  //     slidesPerView: 3,
  //     spaceBetween: 16,
  //     freeMode: true,
  //     pagination: {
  //       el: '.swiper-pagination',
  //       clickable: true,
  //     },
  //     navigation: {
  //       nextEl: '.swiper-button-next',
  //       prevEl: '.swiper-button-prev',
  //     },
  //   });
  //   new Swiper('.store-swiper', {
  //     loop: true,
  //     spaceBetween: 25,
  //     centeredSlides: true,
  //     autoplay: {
	// 			delay: 4500,
	// 			speed: 6000,
  //       disableOnInteraction: false,
  //     },
  //     pagination: {
  //       el: '.swiper-pagination',
  //       clickable: true,
  //     },
  //     navigation: {
  //       nextEl: '.swiper-button-next',
  //       prevEl: '.swiper-button-prev',
  //     },
  //   });
  // },

  initAccordionTriggers() {
    const els = document.querySelectorAll('.entry-summary__accordion-heading');

    const toggleItem = event => {
      event.preventDefault();
      const { parentNode } = event.currentTarget;
      if (parentNode.classList.contains('open')) {
        parentNode.classList.remove('open');
      } else {
        parentNode.classList.add('open');
      }
    }

    Array.from(els).forEach(el => {
      el.addEventListener('click', toggleItem, { capture: true });
    });

    Array.from(els).forEach(el => {
      el.classList.remove('open');
    });

  },

  initRellax() {
    var rellax = new Rellax('.rellax', {
    // new Rellax('.rellax', {
      breakpoints:[320, 768, 1024]
    });
    
  },

  initGuidebookPopup() {
    // console.log('function loaded');
    const downloadButtons = document.querySelectorAll('.button-download');
    // console.log(downloadButton);

   if(downloadButtons) {
    Array.from(downloadButtons).forEach(el => {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        // downloadButton.preventDefault();
        // console.log('button clicked');
        // PopupController.init();
        makePopupInstance(document.querySelector('.popup-section__guidebook'));
      })
    })
   }
    
    // if(downloadButton) {
      
    //   downloadButton.addEventListener('click', function (event) {
    //     event.preventDefault();
    //     // downloadButton.preventDefault();
    //     PopupController.init();
    //   })
    // }
  },

  initContactPopup() {
    // console.log('function loaded');
    const contactButtons = document.querySelectorAll('.button-contact');
    // console.log(downloadButton);

  

   if(contactButtons) {
    Array.from(contactButtons).forEach(el => {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        // downloadButton.preventDefault();
        // console.log('button clicked');
        // PopupController.init();
        makePopupInstance(document.querySelector('.popup-section__contact'));

      })
    })
   }
  },

 


  // initFontSelector() {
  //   // var changeFontStyle = function(font) {
  //   //   document.body.style.fontFamily = font.value;
  //   // }
  // }
}